import { PropsWithChildren } from 'react'
import { IntlProvider } from 'react-intl'
import { DEFAULT_LANGUAGE } from '@renderer/utils/Intl/languageUItils.tsx'

import messages_es from '../../../../internationalization/compiled/es_ES.json'
import messages_en from '../../../../internationalization/compiled/en.json'
import messages_pt from '../../../../internationalization/compiled/pt_BR.json'
import messages_ar from '../../../../internationalization/compiled/ar_SA.json'
import messages_de from '../../../../internationalization/compiled/de_DE.json'
import messages_ko from '../../../../internationalization/compiled/ko_KR.json'
import messages_fr from '../../../../internationalization/compiled/fr_FR.json'
import messages_id from '../../../../internationalization/compiled/id_ID.json'
import messages_pl from '../../../../internationalization/compiled/pl_PL.json'
import messages_tl from '../../../../internationalization/compiled/tl_PH.json'
import messages_th from '../../../../internationalization/compiled/th_TH.json'
import messages_it from '../../../../internationalization/compiled/it_IT.json'
import messages_ru from '../../../../internationalization/compiled/ru_RU.json'
import messages_ja from '../../../../internationalization/compiled/ja_JP.json'
import messages_tr from '../../../../internationalization/compiled/tr_TR.json'
import messages_zh_hans from '../../../../internationalization/compiled//zh_CN.json'
import messages_zh_hant from '../../../../internationalization/compiled//zh_TW.json'
import messages_nl from '../../../../internationalization/compiled//nl_NL.json'
import { useGlobalStore } from '@highlight/ipc/react'

export const messages: any = {
  es: messages_es,
  en: messages_en,
  pt: messages_pt,
  de: messages_de,
  ar: messages_ar,
  ko: messages_ko,
  fr: messages_fr,
  id: messages_id,
  pl: messages_pl,
  tl: messages_tl,
  th: messages_th,
  it: messages_it,
  ru: messages_ru,
  ja: messages_ja,
  tr: messages_tr,
  'zh-Hans': messages_zh_hans,
  'zh-Hant': messages_zh_hant,
  nl: messages_nl,
}

const IntlProviderWrapper = ({ children }: PropsWithChildren) => {
  const [language] = useGlobalStore<string>('settings', 'language')
  const activeLanguage = language || DEFAULT_LANGUAGE

  return (
    <IntlProvider locale={activeLanguage} messages={messages[activeLanguage]}>
      {children}
    </IntlProvider>
  )
}

export { IntlProviderWrapper as IntlProvider }
